<template>
  <div class="dss-nav">
    <div class="w1200">
      <ul>
        <li>
          <router-link to="/">
            <a href="javascript:void(0)"><span>商城首页<i></i></span></a>
          </router-link>
        </li>
        <li>
          <router-link to="/shop_street">
            <a href="javascript:void(0)"><span>店铺街<i></i></span></a>
          </router-link>
        </li>
        <li>
          <router-link :to="{
            path: '/shop/' + store_id
          }">
            <a href="javascript:void(0)"><span>店铺首页<i></i></span></a>
          </router-link>

        </li>
        <li>
          <router-link :to="{
            path: '/shop/goods_list/' + store_id
          }">
            <a href="javascript:void(0)"><span>全部商品<i></i></span></a>
          </router-link>

        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StoreNav',
    data() {
      return {
        store_id: null
      }
    },
    mounted() {
      this.store_id = localStorage.getItem('store_id')
    },
    methods: {

    },
    watch: {}
  }
</script>

<style scoped>
  .dss-nav ul {
    background-color: #ff4040;
    padding: 10px;
  }

  .dss-nav ul li {
    margin-right: 20px;
    display: inline;
  }

  .dss-nav ul li a span {
    font-size: 16px;
    color: #fff;
  }

  .dss-nav ul li a span:hover {
    color: #808080;
  }
</style>
